import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Alert} from './Alert';

@Injectable()
export class AlertService {

  /*
   * Usage:
   * Need to require AlertService
   *
   * this.alertService.danger(new Alert('Message'));
   *
   * Alert properties
   *  - autoHide (boolean) - default true
   *  - autoHideTime (number) - default 5000
   *  - type (string) - default 'danger'
   *  - message (string) - default ''
   *
   * Supported colors: danger, info, warning, success
   *
   */

  alertEvent = new Subject();

  constructor() { }

  private add(alert: Alert) {
    console.log(alert);
    this.alertEvent.next(alert);
  }

  danger(alert: Alert) {
    alert.type = 'danger';
    this.add(alert);
  }

  warning(alert: Alert) {
    alert.type = 'warning';
    this.add(alert);
  }

  info(alert: Alert) {
    alert.type = 'info';
    this.add(alert);
  }

  success(alert: Alert) {
    alert.type = 'success';
    this.add(alert);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/alert/alert.service.ts